<template lang="pug">
.form-utilities
  h2 结算水电

  .ui.four.columns.stackable.grid
    .column(v-for='(utility, index) in utilities')
      utility-view(:key='index', :data='utility' :paid='utilities_paid')
      .ui.field(style='padding:6px')
        el-checkbox(
          v-model='checked[utility.type]'
          label='结算此项'
          :disabled='!utility.mechanical || utilities_paid[utility.type] == utility.mechanical'
        )

  .ui.field
    receipts(:receipts='receipts')

  .ui.field
    label 支付方式
    payment-method-select(v-model='payment_method')


  .ui.field.actions
    .ui.button.themed.icon.labeled(@click='finish()', :class='{disabled:!submitable}')
      i.icon.checkmark
      | 结算
    .ui.button(@click='cancel') 取消
</template>

<script>
import { MakeForm } from '../../utils'
import { AutoTable } from '../auto'
import { Receipts, PaymentMethodSelect, CompareInput, UtilityView } from '../basic'

export default {
  name: 'form-charge',
  props: ['no', 'contract_id'],
  components: {
    AutoTable,
    Receipts,
    PaymentMethodSelect,
    CompareInput,
    UtilityView,
  },
  data: () => ({
    payment_method: 'cash',
    checked: {
      water: true,
      hot_water: true,
      electricity: true,
      kitchen: true,
    },
  }),
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    contract() {
      if (this.contract_id)
        return this.$store.getters.contract(this.contract_id)
      return null
    },
    utilities() {
      return this.room.utilities
    },
    utilities_paid() {
      return this.room.utilities_paid || {}
    },
    submitable() {
      return this.receipts.length
    },
    customers() {
      if (this.contract)
        return this.$store.getters.customers_filter(this.contract._customers)
      return []
    },
    receipts() {
      const receipts = []

      for (const utility of this.room.utilities) {
        if (!this.checked[utility.type])
          // eslint-disable-next-line no-continue
          continue

        let balance = utility.balance
        if (this.$config.logic.manual_meter)
          balance = utility.mechanical - ((this.room.utilities_paid || {})[utility.type] || 0)

        if (balance) {
          receipts.push({
            type: utility.type,
            name: this.$formatters.utility_label(utility.type),
            unit: this.$formatters.utility_unit(utility.type),
            unit_price: this.$formatters.utility_price(utility.type),
            quantity: balance,
            mechanical: utility.mechanical,
          })
        }
      }

      return receipts
    },
  },
  methods: {
    print_charge() {
      this.$templater.request('charge', {
        room: this.room,
        contract: this.contract,
        utilities: this.receipts,
        payment_method: this.payment_method,
        customers: this.customers,
        $methods: this.$store.state.summary.payment_methods,
      })
    },
    finish() {
      if (this.submitable)
        this.sumbit_form()
    },
    sumbit_form: MakeForm({
      type: 'post',
      url: 'charges/settle',
      confirm: (confirm) => (confirm === false ? null : '确定结算水电？'),
      payload() {
        return {
          _room: this.room._id,
          _contract: this.contract ? this.contract._id : null,
          utilities: this.receipts,
          payment_method: this.payment_method,
        }
      },
      $afterSuccess() {
        this.print_charge()
        this.$store.dispatch('load_summary', this)
        this.$router.back()
      },
    }),
    cancel() {
      this.$router.back()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormUtilitiesSettle.vue?27e1086a